
import { emptyPPTReport, FormEditMode, ReportDescription, ReportDisplay, ReportType } from "../../helpers/constants";
import React, { useCallback, useEffect } from "react";
import { PPTReport, PPTRulesCategorisation, PPTRulesDescription, PPTRulesResponse, } from "../../helpers/interfaces";
import { getAllPPTRulesCategorisation, getAllPPTRulesDescription } from "../../apiServices/PPTRulesApi";
import { Button, Table, TableBody, TableContainer, TableHead, useTheme } from "@mui/material";
import { CustomTextField, StyledTableCell, StyledTableRow } from "../../layouts/themes";
import { NumericFormat } from "react-number-format";
import { exportPPTReport, GeneratePPTReports, getAllPPTReports, getGeneratedPPTReports } from "../../apiServices/PPTReportsApi";
import saveAs from "file-saver";
import { useMemo } from 'react';

interface Props {
    pptReportsEditMode: number
    pptReports: PPTReport[]
    setPPTReports: React.Dispatch<React.SetStateAction<PPTReport[]>>
    pptRulesResponse: PPTRulesResponse
    reportDisplay: ReportDisplay
    setReportDisplay: React.Dispatch<React.SetStateAction<ReportDisplay>>
    reportType: ReportType
    pptReportsToEdit: string
    setPPTReportsEditMode: React.Dispatch<React.SetStateAction<number>>
    year: number
}


function ReportView(props: Props) {

    const [report, setReport] = React.useState<PPTReport>(emptyPPTReport)

    const [COSTPERAUDITEDFINSTATID, SetCOSTPERAUDITEDFINSTAT] = React.useState<string>('');
    const [COSTSINCLUDEDINPPTRETURNSID, SetCOSTSINCLUDEDINPPTRETURNS] = React.useState<string>('');
    const [COSTSEXCLUDEDFROMPPTRETURNSID, SetCOSTSEXCLUDEDFROMPPTRETURNS] = React.useState<string>('');
    const [COSTSREPORTEDINPPTRETURNSID, SetCOSTSREPORTEDINPPTRETURNS] = React.useState<string>('');
    const [pptReportsRequest, SetPptReportsRequest] = React.useState<any>();
    const [pptDescriptions, setPPTDescriptions] = React.useState<PPTRulesDescription[]>([])
    const [pptCategorizations, setPPTCategorizations] = React.useState<PPTRulesCategorisation[]>([])

    // const [disallowedCostTotal, SetDisallowedCostTotal] = React.useState<any>();
    const theme = useTheme();


    useEffect(() => {
        if (props.pptReportsEditMode === FormEditMode.EDIT) {
            GetGeneratedPPTReports()
            // getPPTRulesDescription()
            //console.log(pptReportsRequest)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.pptReportsEditMode, props.pptReportsToEdit])

    const GetGeneratedPPTReports = async () => {
        const report = await getGeneratedPPTReports(props.pptReportsToEdit)
        let _report = {
            title: report.title,
            subject: report.subject,
            reportType: report.reportType,
            pptReportsDescriptionRequests: report.pptReportsDescription.map(a => {
                return {
                    pptRulesDescriptionId: a.pptRulesDescriptionId,
                    pptReportsDescriptionCategorisationRequests: a.pptReportsDescriptionCategorisations.map(b => {
                        return {
                            pptRulesCategorisationId: b.pptRulesCategorisationId,
                            amount: b.amount,
                            isManualInput: false
                        }
                    })
                }
            })
        }
        console.log(report, 'report')
        SetPptReportsRequest(_report)
    }

    const nearestThousand = (num: number) => Math.ceil(num / 1000)

    useEffect(() => {

        getAllPPTRulesCategorisation(props.reportType, String(props.year)).then(category => setPPTCategorizations(category.sort((a, b) => a.order - b.order)))
        getPPTRulesDescription()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.reportType])

    const getPPTRulesDescription = async () => {
        const desc = await getAllPPTRulesDescription(props.reportType, String(props.year))

        const _COSTPERAUDITEDFINSTATID = desc?.find(e => e.name === ReportDescription.COSTPERAUDITEDFINSTAT)?.id
        const _COSTSINCLUDEDINPPTRETURNSID = desc?.find(e => e.name === ReportDescription.COSTSINCLUDEDINPPTRETURNS)?.id
        const _COSTSEXCLUDEDFROMPPTRETURNSID = desc?.find(e => e.name === ReportDescription.COSTSEXCLUDEDFROMPPTRETURNS)?.id
        const _COSTSREPORTEDINPPTRETURNSID = desc?.find(e => e.name === ReportDescription.COSTSREPORTEDINPPTRETURNS)?.id
        SetCOSTPERAUDITEDFINSTAT(_COSTPERAUDITEDFINSTATID ?? '');
        SetCOSTSINCLUDEDINPPTRETURNS(_COSTSINCLUDEDINPPTRETURNSID ?? '');
        SetCOSTSEXCLUDEDFROMPPTRETURNS(_COSTSEXCLUDEDFROMPPTRETURNSID ?? '')
        SetCOSTSREPORTEDINPPTRETURNS(_COSTSREPORTEDINPPTRETURNSID ?? '')
        setPPTDescriptions(desc.sort((a, b) => a.order - b.order))

        if (props.pptReportsEditMode !== FormEditMode.EDIT) {
            let request = {
                title: report.title,
                subject: report.subject,
                year: String(props.year),
                reportType: props.reportType,
                pptReportsDescriptionRequests: [
                    // {
                    //     pptRulesDescriptionId: _COSTPERAUDITEDFINSTATID,
                    //     pptReportsDescriptionCategorisationRequests: []
                    // },
                    {
                        pptRulesDescriptionId: _COSTSEXCLUDEDFROMPPTRETURNSID,
                        pptReportsDescriptionCategorisationRequests: []
                    },
                    {
                        pptRulesDescriptionId: _COSTSINCLUDEDINPPTRETURNSID,
                        pptReportsDescriptionCategorisationRequests: []
                    },
                    // {
                    //     pptRulesDescriptionId: _COSTSREPORTEDINPPTRETURNSID,
                    //     pptReportsDescriptionCategorisationRequests: []
                    // },
                    ...props.pptRulesResponse?.pptReports ? props.pptRulesResponse.pptReports.map(a => {
                        return {
                            pptRulesDescriptionId: a.pptRulesDescriptionId,
                            pptReportsDescriptionCategorisationRequests: a.pptRulesDescriptionCategorisations.map(b => {
                                return {
                                    pptRulesCategorisationId: b.pptRulesCategorisationId,
                                    amount: b.amount,
                                    isManualInput: b.isManualInput
                                }
                            })
                        }
                    }) : []
                ]
            }

            SetPptReportsRequest(request)
        }

    }


    const handleUpdateFieldValue = (pptRulesDescriptionId: string, pptRulesCategorisationId: string, amount: string) => {
        let _pptReportsRequest;

        let _pptRulesDescription = pptReportsRequest?.pptReportsDescriptionRequests?.find((a: any) => a.pptRulesDescriptionId === pptRulesDescriptionId);
        if (_pptRulesDescription == null || _pptRulesDescription === undefined) {
            let _newpptRulesDescription = {
                pptRulesDescriptionId: pptRulesDescriptionId,
                pptReportsDescriptionCategorisationRequests: [{
                    pptRulesCategorisationId: pptRulesCategorisationId,
                    amount: amount ? Number.parseInt(amount) * 1000 : amount,
                }]
            }
            _pptReportsRequest = { ...pptReportsRequest, pptReportsDescriptionRequests: [...pptReportsRequest.pptReportsDescriptionRequests, _newpptRulesDescription] }
        }
        else {
            _pptReportsRequest = {
                ...pptReportsRequest, pptReportsDescriptionRequests: pptReportsRequest.pptReportsDescriptionRequests.map((a: any) => {
                    if (a.pptRulesDescriptionId === pptRulesDescriptionId) {

                        let _pptRulesCategorisation = _pptRulesDescription?.pptReportsDescriptionCategorisationRequests?.find((f: any) => f.pptRulesCategorisationId === pptRulesCategorisationId)

                        if (_pptRulesCategorisation === null || _pptRulesCategorisation === undefined) {
                            a.pptReportsDescriptionCategorisationRequests.push({
                                pptRulesCategorisationId: pptRulesCategorisationId,
                                amount: amount ? Number.parseInt(amount) * 1000 : amount,
                            })
                            setReport(report)
                            return a;


                        } else {

                            return { ...a, pptReportsDescriptionCategorisationRequests: a.pptReportsDescriptionCategorisationRequests.map((b: any) => b.pptRulesCategorisationId === pptRulesCategorisationId ? { ...b, amount: amount ? Number.parseInt(amount) * 1000 : amount } : b) }
                        }
                    } else { return a; }

                })
            }
        }
        setReport(_pptReportsRequest)
        SetPptReportsRequest(_pptReportsRequest)
    };

    const getPPTRulesCategorisation = useCallback((pptRulesDescriptionId: string, pptRulesCategorisationId: string) => {
        return pptReportsRequest?.pptReportsDescriptionRequests?.find((a: any) => a.pptRulesDescriptionId === pptRulesDescriptionId)?.pptReportsDescriptionCategorisationRequests?.find((f: any) => f.pptRulesCategorisationId === pptRulesCategorisationId)
    }, [pptReportsRequest]);

  /*   function submitReport() {

        GeneratePPTReports(pptReportsRequest).then(() => {
            getAllPPTReports().then(reports => props.setPPTReports(reports));
        })

        props.setReportDisplay(ReportDisplay.TABLE)
    } */

    function submitReport() {
    pptReportsRequest.pptReportsDescriptionRequests =
        pptReportsRequest.pptReportsDescriptionRequests.filter(
            (r: any) => r.pptRulesDescriptionId
        );
 
    GeneratePPTReports(pptReportsRequest).then(() => {
            getAllPPTReports().then(reports => props.setPPTReports(reports));
        })

        props.setReportDisplay(ReportDisplay.TABLE)
}
    function base64ToBlob(base64string: string, type: string) {
        const binaryString = window.atob(base64string);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return new Blob([bytes], { type: type });
    }

    function exportReport() {
        console.log(props.pptReportsToEdit)
        exportPPTReport(props.pptReportsToEdit).then(async (base64string) => {
            const blob = base64ToBlob(base64string, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            saveAs(blob, `PPTR Report.xlsx`);
        })
    }



    const disallowedCostTotal = useMemo(() => {
        const { total } = pptCategorizations.reduce<{
            total: number;
            cells: JSX.Element[];
        }>(
            (acc, f) => {
                let pptRulesTotal = props.pptRulesResponse?.pptReports?.reduce((sum, v) => sum + (parseFloat(getPPTRulesCategorisation(v.pptRulesDescriptionId, f.id)?.amount) || 0), 0);

                acc.total += pptRulesTotal;
                acc.cells.push(
                    <StyledTableCell key={f.id} style={{ fontWeight: 'bold' }} >
                        {pptRulesTotal?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                    </StyledTableCell>
                );
                return acc;
            },
            { total: 0, cells: [] }
        );
        return total;
    }, [getPPTRulesCategorisation, pptCategorizations, props.pptRulesResponse?.pptReports]);
    return (
        <div>
            {props.pptReportsEditMode !== FormEditMode.EDIT &&
                <div className="mt-4" style={{ float: 'right' }}>
                    <Button color='secondary' variant="contained" onClick={() => submitReport()}>Submit Report</Button>
                </div>
            }
            {props.pptReportsEditMode === FormEditMode.EDIT &&
                <div className="mt-4" style={{ float: 'right' }}>
                    <Button color='info' variant="contained" onClick={() => exportReport()}>Export Report To Excel</Button>
                </div>
            }
            <br />
            <div>
                <div className=' flex flex-row w-full '>
                    <div className=' w-2/4 ' >
                        <div >
                            <label className='title-label'>Title <span className='important'>*</span></label>
                        </div>
                        <div style={{ width: '100%' }} >
                            <div className="form-group mb-0" style={{ width: '100%' }}>
                                <div style={{ width: '100%' }}>
                                    <CustomTextField disabled={props.pptReportsEditMode === FormEditMode.EDIT} size="small" id="outlined-basic" placeholder="Title" value={pptReportsRequest?.title} onChange={(event) => { SetPptReportsRequest({ ...pptReportsRequest, title: event.target.value }) }} variant="outlined" sx={{ width: '100%' }} />

                                </div>
                            </div>
                        </div>

                    </div> &nbsp;&nbsp;&nbsp;

                    <div className='  w-2/4 '>
                        <div >
                            <label className='title-label'>Subject <span className='important'>*</span></label>
                        </div>
                        <div style={{ width: '100%' }} >
                            <div className="form-group mb-0" style={{ width: '100%' }} >
                                <div style={{ width: '100%' }} >
                                    <CustomTextField disabled={props.pptReportsEditMode === FormEditMode.EDIT} size="small" id="outlined-basic" placeholder="Subject" value={pptReportsRequest?.subject} onChange={(event) => { SetPptReportsRequest({ ...pptReportsRequest, subject: event.target.value }) }} variant="outlined" sx={{ width: '100%' }} />

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <br />


                <div className="">
                    <TableContainer className="table table-bordered table-sm table-responsive" sx={{ maxHeight: '56vh', overflowX: 'scroll', overflowY: 'auto', border: '1px solid rgba(224, 224, 224, 1)', '&::-webkit-scrollbar': { width: '6px', height: '6px', }, '&::-webkit-scrollbar-track': { backgroundColor: 'rgba(0,0,0,0.1)', }, '&::-webkit-scrollbar-thumb': { backgroundColor: 'rgba(0,0,0,0.3)', borderRadius: '4px', }, '&::-webkit-scrollbar-thumb:hover': { backgroundColor: 'rgba(0,0,0,0.5)', } }}    >
                        <Table size="small" aria-label="a dense table" aria-labelledby="tableTitle">
                            <TableHead>

                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, textTransform: 'capitalize', fontSize: '12px', minWidth: '250px', fontWeight: 'bold', position: "sticky", top: 0, zIndex: 3 }}><b>Description</b></StyledTableCell>
                                    {pptCategorizations.map(e =>

                                        <StyledTableCell key={e.name} style={{ background: `${theme.palette.error.contrastText}`, textTransform: 'capitalize', fontSize: '12px', minWidth: '250px', fontWeight: 'bold', position: "sticky", top: 0, zIndex: 1 }}>
                                            {e.name}&nbsp;($)
                                        </StyledTableCell>
                                    )}
                                    <StyledTableCell ><b>Total</b></StyledTableCell>
                                </StyledTableRow>

                            </TableHead>
                            <TableBody>
                                <StyledTableRow>
                                    <StyledTableCell
                                        style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}
                                    >
                                        COSTS PER AUDITED FINANCIAL STATEMENT
                                    </StyledTableCell>

                                    {pptCategorizations.reduce<{ total: number; cells: JSX.Element[] }>((acc, e) => {
                                        const amount = getPPTRulesCategorisation(COSTPERAUDITEDFINSTATID, e.id)?.amount || 0;
                                        const numericAmount = parseFloat(amount) || 0;
                                        acc.total += numericAmount;

                                        acc.cells.push(
                                            <StyledTableCell key={e.id} style={{ fontSize: '12px', minWidth: '250px', fontWeight: '' }}>
                                                <>
                                                    {nearestThousand(amount)?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                </>



                                            </StyledTableCell>
                                        );

                                        return acc;
                                    }, { total: 0, cells: [] }).cells}

                                    <StyledTableCell style={{ fontWeight: 'bold' }}>

                                        {nearestThousand(pptCategorizations.reduce((sum, e) => sum + (parseFloat(getPPTRulesCategorisation(COSTPERAUDITEDFINSTATID, e.id)?.amount) || 0), 0))?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                    </StyledTableCell>
                                </StyledTableRow>

                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}>ADD</StyledTableCell>
                                    {pptCategorizations.map(e =>

                                        <StyledTableCell key={e.id} style={{ fontSize: '12px', minWidth: '250px', fontWeight: '' }}>

                                        </StyledTableCell>
                                    )}
                                    <StyledTableCell>0</StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}>COSTS INCLUDED IN PPT RETURNS BUT NOT IN AUDITED FINANCIAL STATEMENT</StyledTableCell>
                                    {pptCategorizations.reduce<{ total: number; cells: JSX.Element[] }>((acc, e) => {
                                        const amount = getPPTRulesCategorisation(COSTSINCLUDEDINPPTRETURNSID, e.id)?.amount || 0;
                                        const numericAmount = parseFloat(amount) || 0;
                                        acc.total += numericAmount;

                                        acc.cells.push(
                                            <StyledTableCell key={e.id} style={{ fontSize: '12px', minWidth: '250px', fontWeight: '' }}>
                                                <NumericFormat
                                                    disabled={props.pptReportsEditMode === FormEditMode.EDIT}
                                                    size="small"
                                                    customInput={CustomTextField}
                                                    id="outlined-basic"
                                                    name="amount"
                                                    placeholder="Amount"
                                                    variant="outlined"
                                                    value={amount ? nearestThousand(amount) : amount}
                                                    style={{ width: '100%' }}
                                                    onChange={(event: { target: { value: string } }) =>
                                                        handleUpdateFieldValue(COSTSINCLUDEDINPPTRETURNSID, e.id, event.target.value)
                                                    }
                                                />
                                            </StyledTableCell>
                                        );

                                        return acc;
                                    }, { total: 0, cells: [] }).cells}

                                    <StyledTableCell style={{ fontWeight: 'bold' }}>

                                        {nearestThousand(pptCategorizations.reduce((sum, e) => sum + (parseFloat(getPPTRulesCategorisation(COSTSINCLUDEDINPPTRETURNSID, e.id)?.amount) || 0), 0))?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                    </StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1, }}></StyledTableCell>
                                    {pptCategorizations.map(e =>

                                        <StyledTableCell key={e.id} style={{ fontSize: '12px', minWidth: '250px', fontWeight: '' }}>

                                        </StyledTableCell>
                                    )}
                                    <StyledTableCell></StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}>   LESS</StyledTableCell>
                                    {pptCategorizations.map(e =>

                                        <StyledTableCell key={e.id} style={{ fontSize: '12px', minWidth: '250px', fontWeight: '' }}>

                                        </StyledTableCell>
                                    )}
                                    <StyledTableCell>0</StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}>COSTS IN AUDITED FINANCIAL STATEMENT BUT EXCLUDED FROM PPT RETURNS</StyledTableCell>
                                    {pptCategorizations.reduce<{ total: number; cells: JSX.Element[] }>((acc, e) => {
                                        const amount = getPPTRulesCategorisation(COSTSEXCLUDEDFROMPPTRETURNSID, e.id)?.amount || 0;
                                        const numericAmount = parseFloat(amount) || 0;
                                        acc.total += numericAmount;

                                        acc.cells.push(
                                            <StyledTableCell key={e.id} style={{ fontSize: '12px', minWidth: '250px', fontWeight: '' }}>
                                                <NumericFormat
                                                    disabled={props.pptReportsEditMode === FormEditMode.EDIT}
                                                    size="small"
                                                    customInput={CustomTextField}
                                                    id="outlined-basic"
                                                    name="amount"
                                                    placeholder="Amount"
                                                    variant="outlined"
                                                    value={amount ? nearestThousand(amount) : amount}
                                                    style={{ width: '100%' }}
                                                    onChange={(event: { target: { value: string } }) =>
                                                        handleUpdateFieldValue(COSTSEXCLUDEDFROMPPTRETURNSID, e.id, event.target.value)
                                                    }
                                                />
                                            </StyledTableCell>
                                        );

                                        return acc;
                                    }, { total: 0, cells: [] }).cells}

                                    <StyledTableCell style={{ fontWeight: 'bold' }}>
                                        {nearestThousand(pptCategorizations.reduce((sum, e) => sum + (parseFloat(getPPTRulesCategorisation(COSTSEXCLUDEDFROMPPTRETURNSID, e.id)?.amount) || 0), 0))?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                    </StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}>DISALLOWED COSTS</StyledTableCell>


                                </StyledTableRow>
                                {props.pptReportsEditMode !== FormEditMode.EDIT ?
                                    <>
                                        {props.pptRulesResponse?.pptReports?.map((e, index) => {
                                            let desc = pptDescriptions.find(d => d.id === e.pptRulesDescriptionId)!
                                            console.log(desc, 'desc')
                                            return desc?.name !== ReportDescription.COSTSREPORTEDINPPTRETURNS && desc?.name !== ReportDescription.COSTPERAUDITEDFINSTAT && <StyledTableRow key={index}>


                                                <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', minWidth: '350px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}>
                                                    {desc?.name}

                                                </StyledTableCell>

                                                {pptCategorizations.reduce<{ total: number; cells: JSX.Element[] }>((acc, f) => {
                                                    const categ = getPPTRulesCategorisation(e.pptRulesDescriptionId, f.id)
                                                    const amount = categ?.amount;
                                                    const numericAmount = parseFloat(amount) || 0;
                                                    acc.total += numericAmount;

                                                    acc.cells.push(
                                                        <StyledTableCell key={e.id} style={{ fontSize: '12px', minWidth: '250px', fontWeight: '' }}>
                                                            {categ?.isManualInput ? <>
                                                                <NumericFormat
                                                                    disabled={props.pptReportsEditMode === FormEditMode.EDIT}
                                                                    size="small"
                                                                    customInput={CustomTextField}
                                                                    id="outlined-basic"
                                                                    name="amount"
                                                                    placeholder="Amount"
                                                                    variant="outlined"
                                                                    value={amount ? nearestThousand(amount) : amount}
                                                                    style={{ width: '100%' }}
                                                                    onChange={(event: { target: { value: string } }) => handleUpdateFieldValue(e.pptRulesDescriptionId, f.id, event.target.value)
                                                                    }
                                                                />
                                                            </> : <>
                                                                {amount ? nearestThousand(amount)?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) : amount}
                                                            </>}
                                                        </StyledTableCell>
                                                    );

                                                    return acc;
                                                }, { total: 0, cells: [] }).cells}

                                                <StyledTableCell style={{ fontWeight: 'bold' }}>
                                                    {nearestThousand(pptCategorizations.reduce((sum, f) => sum + (parseFloat(getPPTRulesCategorisation(e.pptRulesDescriptionId, f.id)?.amount) || 0), 0))?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                </StyledTableCell>
                                            </StyledTableRow>

                                        })}
                                    </>
                                    :
                                    <>
                                        {pptDescriptions
                                            .filter(desc => {
                                                // Exclude the same descriptions that are commented out in non-edit mode
                                                return desc.id !== COSTPERAUDITEDFINSTATID &&
                                                    desc.id !== COSTSREPORTEDINPPTRETURNSID &&
                                                    pptReportsRequest?.pptReportsDescriptionRequests?.find((descRequest: { pptRulesDescriptionId: string; }) => descRequest.pptRulesDescriptionId === desc.id)
                                            })

                                            .map((desc) => {
                                                const request = pptReportsRequest.pptReportsDescriptionRequests.find((req: { pptRulesDescriptionId: string; }) => req.pptRulesDescriptionId === desc.id);
                                                return (<StyledTableRow key={desc.id}>


                                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', minWidth: '350px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}>
                                                        {desc?.name}

                                                    </StyledTableCell>

                                                    {pptCategorizations.reduce<{ total: number; cells: JSX.Element[] }>((acc, f) => {
                                                        const categ = getPPTRulesCategorisation(request?.pptRulesDescriptionId, f.id)
                                                        const amount = categ?.amount;
                                                        const numericAmount = parseFloat(amount) || 0;
                                                        acc.total += numericAmount;

                                                        acc.cells.push(
                                                            <StyledTableCell key={request?.pptRulesDescriptionId} style={{ fontSize: '12px', minWidth: '250px', fontWeight: '' }}>
                                                                {categ?.isManualInput ? <>
                                                                    <NumericFormat
                                                                        disabled={props.pptReportsEditMode === FormEditMode.EDIT}
                                                                        size="small"
                                                                        customInput={CustomTextField}
                                                                        id="outlined-basic"
                                                                        name="amount"
                                                                        placeholder="Amount"
                                                                        variant="outlined"
                                                                        value={amount ? nearestThousand(amount) : amount}
                                                                        style={{ width: '100%' }}
                                                                        onChange={(event: { target: { value: string } }) => handleUpdateFieldValue(request?.pptRulesDescriptionId, f.id, event.target.value)
                                                                        }
                                                                    />
                                                                </> : <>
                                                                    {amount ? nearestThousand(amount)?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) : amount}
                                                                </>}
                                                            </StyledTableCell>
                                                        );

                                                        return acc;
                                                    }, { total: 0, cells: [] }).cells}

                                                    <StyledTableCell style={{ fontWeight: 'bold' }}>
                                                        {nearestThousand(pptCategorizations.reduce((sum, f) => sum + (parseFloat(getPPTRulesCategorisation(request?.pptRulesDescriptionId, f.id)?.amount) || 0), 0))?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                                )
                                            })}
                                    </>}
                                <StyledTableRow style={{ borderBottom: '2px solid #6c6c6cff', borderTop: '2px solid #6c6c6cff' }}>

                                    {(() => {
                                        return (() => {
                                            const { total, cells } = pptCategorizations.reduce<{
                                                total: number;
                                                cells: JSX.Element[];
                                            }>(
                                                (acc, f) => {
                                                    let pptRulesTotal = props.pptRulesResponse?.pptReports?.reduce((sum, v) => {
                                                        return v.pptRulesDescriptionId !== COSTPERAUDITEDFINSTATID && v.pptRulesDescriptionId !== COSTSREPORTEDINPPTRETURNSID ? sum + (parseFloat(getPPTRulesCategorisation(v.pptRulesDescriptionId, f.id)?.amount) || 0
                                                        ) : sum
                                                    }, 0);

                                                    acc.total += pptRulesTotal ?? 0; // Update total in accumulator

                                                    acc.cells.push(

                                                        <StyledTableCell key={f.id} style={{ fontWeight: 'bold' }} >
                                                            {nearestThousand(pptRulesTotal)?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                        </StyledTableCell>
                                                    );

                                                    return acc;
                                                },
                                                { total: 0, cells: [] } // Ensure TypeScript understands the structure
                                            );

                                            return (
                                                <>
                                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', minWidth: '350px', fontWeight: '500', position: "sticky", left: 0, zIndex: 1 }}></StyledTableCell>
                                                    {cells}
                                                    <StyledTableCell style={{ fontWeight: 'bold' }}>{nearestThousand(total)?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}</StyledTableCell>
                                                </>
                                            );
                                        })();
                                    })()}


                                </StyledTableRow>

                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1 }}>   </StyledTableCell>
                                    {pptCategorizations.map(e =>

                                        <StyledTableCell key={e.id} style={{ fontSize: '12px', minWidth: '250px', fontWeight: '' }}>

                                        </StyledTableCell>
                                    )}
                                    <StyledTableCell>0</StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow style={{ borderBottom: '2px solid #6c6c6cff', borderTop: '2px solid #6c6c6cff' }}>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1, }}>TOTAL COSTS PER PPT RETURNS</StyledTableCell>
                                    {pptCategorizations.map(s => {
                                        return (
                                            <StyledTableCell key={s.id} style={{ fontWeight: 'bold' }}>
                                                {(props.pptRulesResponse?.pptReports?.reduce((sum, v) => {
                                                    return v.pptRulesDescriptionId !== COSTPERAUDITEDFINSTATID && v.pptRulesDescriptionId !== COSTSREPORTEDINPPTRETURNSID ? sum + (nearestThousand(parseFloat(getPPTRulesCategorisation(v.pptRulesDescriptionId, s.id)?.amount)) || 0
                                                    ) : sum
                                                }, 0) + (nearestThousand(parseFloat(getPPTRulesCategorisation(COSTPERAUDITEDFINSTATID, s.id)?.amount)) || 0))?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                            </StyledTableCell>
                                        );
                                    })}
                                    <StyledTableCell style={{ fontWeight: 'bold' }}>
                                        {nearestThousand((
                                            (disallowedCostTotal) +
                                            (pptCategorizations.reduce((sum, e) => sum + (parseFloat(getPPTRulesCategorisation(COSTPERAUDITEDFINSTATID, e.id)?.amount) || 0), 0))
                                        ))?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                    </StyledTableCell>
                                </StyledTableRow>
                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1, }}>The explanations provided should be sufficient to enable the auditors to verify</StyledTableCell>

                                </StyledTableRow>
                                <StyledTableRow>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1, }}>COST REPORTED IN THE PPT RETURNS</StyledTableCell>
                                    {pptCategorizations.reduce<{ total: number; cells: JSX.Element[] }>((acc, e) => {
                                        const amount = getPPTRulesCategorisation(COSTSREPORTEDINPPTRETURNSID, e.id)?.amount || 0;
                                        const numericAmount = parseFloat(amount) || 0;
                                        acc.total += numericAmount;

                                        acc.cells.push(
                                            <StyledTableCell key={e.id} style={{ fontSize: '12px', minWidth: '250px', fontWeight: '', }}>
                                                <>
                                                    {nearestThousand(amount)?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                                </>
                                                {/* <NumericFormat
                                                    disabled={props.pptReportsEditMode === FormEditMode.EDIT}
                                                    size="small"
                                                    customInput={CustomTextField}
                                                    id="outlined-basic"
                                                    name="amount"
                                                    placeholder="Amount"
                                                    variant="outlined"
                                                    value={amount}
                                                    style={{ width: '100%' }}
                                                    onChange={(event: { target: { value: string } }) =>
                                                        handleUpdateFieldValue(COSTSREPORTEDINPPTRETURNSID, e.id, event.target.value)
                                                    }
                                                /> */}
                                            </StyledTableCell>
                                        );

                                        return acc;
                                    }, { total: 0, cells: [] }).cells}

                                    <StyledTableCell style={{ fontWeight: 'bold' }}>
                                        {nearestThousand(pptCategorizations.reduce((sum, e) => sum + (parseFloat(getPPTRulesCategorisation(COSTSREPORTEDINPPTRETURNSID, e.id)?.amount) || 0), 0)).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                    </StyledTableCell>
                                </StyledTableRow>

                                <StyledTableRow style={{ borderBottom: '2px solid #6c6c6cff', borderTop: '2px solid #6c6c6cff' }}>
                                    <StyledTableCell style={{ background: `${theme.palette.error.contrastText}`, fontSize: '11px', fontWeight: 'bold', position: "sticky", left: 0, zIndex: 1, }}>DIFFERENCE</StyledTableCell>
                                    {pptCategorizations.map(e =>

                                        // <StyledTableCell key={e.id} style={{ fontSize: '12px', minWidth: '350px', fontWeight: 'bold' }}>
                                        //     {(
                                        //         Math.abs(nearestThousand(props.pptRulesResponse?.pptReports?.reduce((sum, v) => {
                                        //             return v.pptRulesDescriptionId !== COSTPERAUDITEDFINSTATID && v.pptRulesDescriptionId !== COSTSREPORTEDINPPTRETURNSID ? sum + (parseFloat(getPPTRulesCategorisation(v.pptRulesDescriptionId, e.id)?.amount) || 0
                                        //             ) : sum
                                        //         }, 0) +
                                        //             (parseFloat(getPPTRulesCategorisation(COSTPERAUDITEDFINSTATID, e.id)?.amount)) || 0)) -
                                        //         Math.abs(nearestThousand(parseFloat(getPPTRulesCategorisation(COSTSREPORTEDINPPTRETURNSID, e.id)?.amount)) || 0))?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}

                                        // </StyledTableCell>
                                            <StyledTableCell key={e.id} style={{ fontSize: '12px', minWidth: '350px', fontWeight: 'bold' }}>
                                            {(Math.abs(nearestThousand(parseFloat(getPPTRulesCategorisation(COSTSREPORTEDINPPTRETURNSID, e.id)?.amount) || 0)) -

                                                Math.abs(nearestThousand(props.pptRulesResponse?.pptReports?.reduce((sum, v) => {
                                                    return v.pptRulesDescriptionId !== COSTPERAUDITEDFINSTATID && v.pptRulesDescriptionId !== COSTSREPORTEDINPPTRETURNSID ? sum + (parseFloat(getPPTRulesCategorisation(v.pptRulesDescriptionId, e.id)?.amount) || 0
                                                    ) : sum
                                                }, 0) +
                                                    (parseFloat(getPPTRulesCategorisation(COSTPERAUDITEDFINSTATID, e.id)?.amount) || 0))
                                                    ))?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}

                                        </StyledTableCell>

                                    )}
                                    <StyledTableCell style={{ fontWeight: 'bold' }}>
                                        {nearestThousand(((
                                            (disallowedCostTotal) +
                                            (pptCategorizations.reduce((sum, e) => sum + (parseFloat(getPPTRulesCategorisation(COSTPERAUDITEDFINSTATID, e.id)?.amount) || 0), 0))
                                        ) - (pptCategorizations.reduce((sum, e) => sum + (parseFloat(getPPTRulesCategorisation(COSTSREPORTEDINPPTRETURNSID, e.id)?.amount) || 0), 0))))?.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
                                    </StyledTableCell>
                                </StyledTableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>

        </div>
    )
}
export default ReportView